// 考试模式
export enum ExamModeEnum {
  /**
   * 每日打卡
   */
  PunchInDaily = 1,
  /**
   * 章节练习
   */
  ChapterPractice = 2,
  /**
   * 普通考试
   */
  NormalExam = 3,
  /**
   * 模拟考场
   */
  ImitateExam = 4,
  /**
   * 历年试题
   */
  PreviousExam = 5,
}

// 作答模式
export enum AnswerModeEnum {
  /**
   * 默认模式
   */
  DefaultMode = 0,
  /**
   * 考试模式
   */
  NormalExamMode = 1,
  /**
   * 练习模式
   */
  PracticeMode = 2,
  /**
   * 机考模式
   */
  ComputerExamMode = 3,
}

// 二次作答类型枚举
export enum SecondaryAnswerTypeEnum {
  Reset = '1',
  Continue = '2',
}

// 题目作答结果状态枚举
export enum QuestAnswerStatus {
  Undo = 0,
  Success = 1,
  Failed = 2,
  QuestSubjective = 3,
  WithFlag = 4,
}
